<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li>
          <a class="link-effect" [routerLink]="['/vigilancia', 'accesos']"
            >Consulta de Acceso</a
          >
        </li>
        <li><span class="link-effect">Detalle</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Consulta de Acceso</h3>
    </div>

    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-1 control-label">Apellido Paterno:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Apellido Paterno:</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="model.apellidoPaterno"
                disabled
              />
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Apellido Materno:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Apellido Materno:</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="model.apellidoMaterno"
                disabled
              />
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-1 control-label">Nombres:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Nombres:</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="model.nombres"
                disabled
              />
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Nro Documento de Identidad:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Nro Documento de Identidad:</mat-label>
              <input matInput type="text" [(ngModel)]="model.nroDocumentoIdentidad" disabled />
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-1 control-label">Cargo:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Cargo:</mat-label>
              <input matInput type="text" [(ngModel)]="model.cargo" disabled />
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Fecha Inicio:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Fecha Inicio:</mat-label>
              <input
                matInput
                type="text"
                [ngModel]='model.fechaInicio | date: "dd/MM/yyyy"'
                disabled
              />
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-1 control-label">Estado:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Estado:</mat-label>
              <input matInput type="text" [(ngModel)]="model.estado" disabled />
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Fecha Fin:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Fecha Fin:</mat-label>
              <input
                matInput
                type="text"
                [ngModel]='model.fechaFin | date: "dd/MM/yyyy"'
                disabled
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>  
    <!-- <div class="block-content">
      <div class="form-horizontal">
        <mat-divider class="engie-divider"></mat-divider>
      </div>
    </div> -->
    
    <div class="content">
      <div class="block">
        <div class="block-header">
          <h3 class="block-title">Documentación Requerida</h3>
        </div>

        <mat-tab-group>
          <mat-tab label="Personal">
            <div class="block-content">
              <div class="table-responsive">
                <table mat-table [dataSource]="model.documentos" class="table table-striped table-vcenter">
                  <ng-container matColumnDef="documentoRequerido">
                    <th mat-header-cell *matHeaderCellDef>Documento</th>
                    <td mat-cell *matCellDef="let element">{{ element.solicitudDocumentoRequerido }}</td>
                  </ng-container>
          
                  <ng-container matColumnDef="requisito">
                    <th mat-header-cell *matHeaderCellDef>Requisito</th>
                    <td mat-cell *matCellDef="let element">{{ element.requisito }}</td>
                  </ng-container>
      
                  <ng-container matColumnDef="fechaVencimiento">
                    <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.fechaVencimiento | date: 'dd/MM/yyyy'}}
                    </td>
                  </ng-container>
      
                  <ng-container matColumnDef="nombreArchivo">
                    <th mat-header-cell *matHeaderCellDef>Doc.</th>
                    <td mat-cell *matCellDef="let element">
                      <!-- <a>VER</a> -->
                      <a (click)="downloadDocumentFromService(element)">{{element.nombreArchivo}}</a>
                    </td>
                  </ng-container>
                  
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Equipos">
            <div class="block-content">
              <div class="table-responsive">
                <table mat-table [dataSource]="model.solicitudEquipos" class="table table-striped table-vcenter">
                  <ng-container matColumnDef="marca">
                    <th mat-header-cell *matHeaderCellDef>Marca</th>
                    <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
                  </ng-container>
          
                  <ng-container matColumnDef="modelo">
                    <th mat-header-cell *matHeaderCellDef>Modelo</th>
                    <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
                  </ng-container>
      
                  <ng-container matColumnDef="serie">
                    <th mat-header-cell *matHeaderCellDef>Serie</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.serie}}
                    </td>
                  </ng-container>
      
                  <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef>Estado</th>
                    <td mat-cell *matCellDef="let element">
                      {{element.estado}}
                    </td>
                  </ng-container>
                  
                  <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef>Acciones</th>
                    <td mat-cell *matCellDef="let element">
                    <button
                        mat-icon-button
                        color="primary"
                        aria-label="Editar"
                        (click)="openDialogEquipo(element)"
                    >
                        <mat-icon>search</mat-icon>
                    </button>
                    </td>
                  </ng-container>
                  
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsEquipo"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsEquipo"></tr>
                </table>
                <div *ngIf="!model.solicitudEquipos.length">
                  No se registraron equipos
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Vehiculos">
            <div class="block-content">
              <div class="table-responsive">
                <table mat-table [dataSource]="model.solicitudVehiculos" class="table table-striped table-vcenter">
                  <ng-container matColumnDef="marca">
                    <th mat-header-cell *matHeaderCellDef>Marca</th>
                    <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
                  </ng-container>
          
                  <ng-container matColumnDef="modelo">
                    <th mat-header-cell *matHeaderCellDef>Modelo</th>
                    <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
                  </ng-container>
      
                  <ng-container matColumnDef="placa">
                    <th mat-header-cell *matHeaderCellDef>Placa</th>
                    <td mat-cell *matCellDef="let element">{{ element.placa }}</td>
                  </ng-container>
      
                  <ng-container matColumnDef="color">
                    <th mat-header-cell *matHeaderCellDef>Color</th>
                    <td mat-cell *matCellDef="let element">{{element.color}}</td>
                  </ng-container>

                  <ng-container matColumnDef="anio">
                    <th mat-header-cell *matHeaderCellDef>Año</th>
                    <td mat-cell *matCellDef="let element">{{element.anio}}
                    </td>
                  </ng-container>
                  
                  <ng-container matColumnDef="chofer">
                    <th mat-header-cell *matHeaderCellDef>Chofer</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.solicitudChofer.nombres +
                          " " +
                          element.solicitudChofer.apellidoPaterno +
                          " " +
                          element.solicitudChofer.apellidoMaterno
                      }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef>Estado</th>
                    <td mat-cell *matCellDef="let element">{{element.estado}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef>Acciones</th>
                    <td mat-cell *matCellDef="let element">
                      <button
                        mat-icon-button
                        color="primary"
                        aria-label="Editar"
                        (click)="openDialogVehiculo(element)"
                      >
                        <mat-icon>search</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsVehiculo"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsVehiculo"></tr>
                </table>
                <div *ngIf="!model.solicitudVehiculos.length">
                  No se registraron vehículos
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Documentación técnica">
            <div class="block-content">
              <div class="table-responsive">
                <table mat-table [dataSource]="model.solicitudDocumentosTecnicos" class="table table-striped table-vcenter">
                  <!-- <ng-container matColumnDef="documentoRequerido">
                    <th mat-header-cell *matHeaderCellDef>Documento</th>
                    <td mat-cell *matCellDef="let element">{{ element.solicitudDocumentoRequerido }}</td>
                  </ng-container> -->
                  <ng-container matColumnDef="nombre">
                    <th mat-header-cell *matHeaderCellDef>Nombre</th>
                    <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                  </ng-container>

                  <ng-container matColumnDef="requisito">
                    <th mat-header-cell *matHeaderCellDef>Requisito</th>
                    <td mat-cell *matCellDef="let element">{{ element.requisito }}</td>
                  </ng-container>
      
                  <ng-container matColumnDef="fechaVencimiento">
                    <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.fechaVencimiento | date: 'dd/MM/yyyy'}}
                    </td>
                  </ng-container>
      
                  <ng-container matColumnDef="nombreArchivo">
                    <th mat-header-cell *matHeaderCellDef>Doc.</th>
                    <td mat-cell *matCellDef="let element">
                      <!-- <a>VER</a> -->
                      <a (click)="downloadDocumentoTecnicoFromService(element)">{{element.nombreArchivo}}</a>
                    </td>
                  </ng-container>
                  
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsDocumentoTecnico"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsDocumentoTecnico"></tr>
                </table>
                <div *ngIf="!model.solicitudDocumentosTecnicos.length">
                    No se registraron documentos
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  